import router from '@/views/routers'
import store from '@/core/store'
import {Alert, PageUtils} from '@/core/utils'
import ApiErrorValidations from '@/core/exceptions/ApiErrorValidations'
import {mensagens, mutationTypes} from '@/core/constants'

const alert = new Alert(store)
const pageUtils = new PageUtils(router)

class ExceptionHandler {
    execute(error) {
        if (error instanceof ApiErrorValidations) {
            this.tratarValidationError(error)
        } else {
            this.tratarError(error)
        }
        store.commit(mutationTypes.SET_DESABILITAR_SALVAMENTO_AUTOMATICO)
    }

    tratarValidationError(error) {
        if (error.multipleErrors()) {
            this.handleMultipleErrors(error.response.data.errorMessages)
        } else if (error.disconnected()) {
            this.handleDisconnected()
        } else if (error.unauthorized()) {
            this.handleUnauthorized()
        } else if (error.internalError()) {
            this.handleInternalError(error)
        } else if (error.serviceUnavailable()){
            this.handleUnavailable()
        } else if (error.forbidden()) {
            this.handleForbidden()
        }
        else {
            if(error.response.data && error.response.data.message)
                alert.showError(error.response.data.message)
            else
                this.handleUnknown()
        }
    }

    tratarError(error) {
        alert.showError(error.message)
    }

    handleMultipleErrors(errors) {
        const errorMsg = errors.map(err => err.message).reduce((total, prox) => {
            return total + ' \n' + prox
        })
        alert.showError(errorMsg)
    }

    handleDisconnected() {
        alert.showError(mensagens.DISCONNECTED)
        pageUtils.goToHome()
    }

    handleUnauthorized() {
        alert.showError(mensagens.LOST_SESSION)
        pageUtils.reload()
    }

    handleForbidden() {
        alert.showError(mensagens.FORBIDDEN_MESSAGE)
        pageUtils.goToHome()
    }

    handleNotFound(error) {
        this.handleInternalError(error)
        pageUtils.goToHome()
    }

    handleInternalError(error) {
        let msgFormatted = ''
        let res = null
        if (error.response.request.responseType === 'arraybuffer' && error.response.data.toString() === '[object ArrayBuffer]'){
            res = JSON.parse(Buffer.from(error.response.data).toString('utf8'))
            msgFormatted = res.message
        }else{
            msgFormatted = error.response.data.message
        }
        if (msgFormatted) {
            alert.showError(msgFormatted)
        } else {
            this.handleUnknown()
        }
    }

    handleUnavailable(){
        alert.showError(mensagens.INDISPONIVEL)
    }

    handleUnknown() {
        alert.showError(mensagens.UNKNOWN)
    }
}

export default new ExceptionHandler()
